import React           from 'react';
import PropTypes       from '../PropTypes';
import ValueLabel      from '../ValueLabel';
import ComponentHelper from '../../helper/ComponentHelper';

class TableBoldTextFormatter extends React.Component {
    render () {
        return (
            <ValueLabel
                showBold={true}
                value={this.props.value}
            />
        );
    }

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = TableBoldTextFormatter;

Component.propTypes = {
    value: PropTypes.any,
};

Component.defaultProps = {
    value: [],
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;